<template>
  <b-container fluid class="d-flex p-0" style="height: 80vh">
    <v-navigation-drawer
      :mini-variant.sync="mini"
      permanent
      class="iq-card mobile-hide"
      :style="{ flex: mini ? '0 1 50px' : '0 1 320px',  'margin-right': '15px'}"
    >
    <v-list-item class="px-2" @click.stop="mini = !mini">
        <v-list dense>
          <v-list-item link style="margin: -5px">

            <v-list-item-icon>
              <h4 class="card-title title-typography-color">
                <i class="fas fa-chevron-right" v-if="mini"></i>
                <i class="fas fa-chevron-left" v-else></i>
              </h4>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-list-item>
      <v-list-item class="px-2">
        <v-list dense>
          <v-list-item link style="margin: -16px">
            <v-list-item-icon>
              <h4 class="card-title title-typography-color">
                <i class="fas fa-users"></i>
              </h4>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <h3 class="ml-2 card-title title-typography-color">
                  {{ $t("public.views.Chat.Index.partakers") }}
                </h3>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item>

      <v-list dense>
        <v-list-item
          v-for="(item, index) in usersChat"
          :key="index"
          class="px-1"
        >
          <v-list-item-avatar>
            <b-avatar v-bind:src="item.image
                    ? item.image +
                    '/' +
                    getAuthentication()
                    : ''
                    "></b-avatar>
            <span class="avatar-status" v-if="callerSession">
              <i class="ri-checkbox-blank-circle-fill" :class="`text-${item.status}`"></i>
            </span>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>
              <div class="media-support-info ml-3">
                <h6>{{ item.name }}</h6>
                <p v-if="item.you" class="mb-0 font-size-12" style="color: #a09e9e">(Tú)</p>
                <p class="mb-0 font-size-12" style="color: #a09e9e">{{ item.role }}</p>
                <!--
                <p
                  v-if="!item.you && user.role !== 'PATIENT' && event && event.professionalLead && event.professionalLead.id === user.id"
                  class="mb-0 font-size-12"
                  style="color: #a09e9e"
                >
                  <b-button size="sm" @click="sendMuteAudioUser(item.id)" class="mr-2" variant="primary">
                    <i class="fas fa-microphone-slash"></i>
                  </b-button>
                  <b-button size="sm" @click="sendMuteVideoUser(item.id)" class="mr-2" variant="primary">
                    <i class="fas fa-video-slash"></i>
                  </b-button>
                </p>
                -->
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list-item class="px-2">
        <v-list dense>
          <v-list-item link style="margin: -16px">
            <v-list-item-icon>
              <h4 class="card-title title-typography-color">
                <i class="fas fa-sliders-h"></i>
              </h4>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <h3 class="ml-2 card-title title-typography-color">
                  {{ $t("public.views.Chat.Index.details") }}
                </h3>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item>
      <v-list-item class="px-2">
        <v-list dense>
          <v-list-item class="px-1" v-if="event && event.visitType">
            <p>
              <i class="fas fa-calendar-alt fa-fw" style="color: #a09e9e; font-size: 18px; margin-bottom: 0"></i>
            </p>
            <v-list-item-content>
              <v-list-item-title class="ml-2">
                <p style="color: #a09e9e; font-size: 18px; margin-bottom: 0">
                  {{ event.startedAt | adjustToTimezone("HH:mm") }} - {{ getFinishAtCalculated() |  adjustToTimezone("HH:mm")}}
                </p>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-1" v-if="event && event.visitType">
            <p>
              <i class="fas fa-hourglass-half fa-fw" style="color: #a09e9e; font-size: 18px"></i>
            </p>
            <v-list-item-content class="ml-2">
              <v-list-item-title>
                <p style="color: #a09e9e; font-size: 18px; margin-bottom: 0">
                  {{ event.visitType.duration + event.extraTime }} {{ $t("public.views.Chat.Index.min") }}.
                </p>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="px-1">
            <p>
              <i class="fas fa-hourglass-half fa-fw" style="color: #a09e9e; font-size: 18px; margin-bottom: 0"></i>
            </p>
            <v-list-item-content class="ml-3">
              <v-list-item-title>
                <p style="color: #a09e9e; font-size: 18px; margin-bottom: 0">
                  Iniciado: {{ initAt | adjustToTimezone("HH:mm") }}
                </p>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item>
    </v-navigation-drawer>

    <div class="flex-fill d-flex flex-column">
      <iq-card class="flex-fill">
        <template v-slot:headerTitle>
          <div class="d-flex justify-content-center w-100 card-title title-typography-color">
            {{ remainingMinutes }} min.
          </div>
          <div class="d-flex justify-content-center w-100 header-actions">
            <b-button class="m-2" variant="danger" @click="stopScreenSharing" v-if="isScreenSharing">
              Dejar de compartir
            </b-button>
            <b-button class="m-2" variant="success" @click="shareScreenSharing" v-if="!isScreenSharing">
              Compartir
            </b-button>
            <b-button class="m-2" variant="success" @click="setEventExtraTimeEvent" v-if="user.role !== 'PATIENT'">
              +5
            </b-button>
            <b-button class="m-2" variant="danger" @click="finish" v-if="user.role !== 'PATIENT'">
              Cerrar
            </b-button>
          </div>
        </template>
        <b-card-text class="d-flex flex-column flex-grow-1">
          <b-container fluid class="video-container flex-grow-1 p-0">
            <ot-subscriber
              v-if="agentStream"
              :key="agentStream.id"
              @error="errorHandler"
              :stream="agentStream"
              :session="callerSession"
              :opts="subscriberOpts"
              class="subscriber flex-grow-1"
            ></ot-subscriber>
            <div  class="d-flex justify-content-center w-100 mt-4" v-if="!agentStream">Esperando al participante...</div>
            <ot-publisher
            ref="publisher"
            v-if="callerSession"
            :session="callerSession"
            :opts="publisherOpts"
            :isScreenSharing.sync="isScreenSharing"
            @error="errorHandler"
            class="publisher floating mobile-hide"
          ></ot-publisher>
          </b-container>
        </b-card-text>
      </iq-card>
    </div>

    <v-navigation-drawer
      :mini-variant.sync="chatMini"
      permanent
      right
      :style="{ flex: chatMini ? '0 1 50px' : '0 1 320px',  'margin-left': '15px' }"
      class="iq-card mobile-upfloat"
    >
    <v-list-item class="px-2" @click.stop="chatMini = !chatMini">
        <v-list dense>
          <v-list-item link style="margin: -5px">

            <v-list-item-icon>
              <h4 class="card-title title-typography-color">
                <i class="fas fa-chevron-left" v-if="chatMini"></i>
                <i class="fas fa-chevron-right" v-else></i>
              </h4>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-list-item>
      <v-list-item class="px-2">
        <v-list dense class="mt-10">
          <v-list-item link style="margin: -15px">
            <v-list-item-icon>
              <h4 class="card-title title-typography-color">
                <i class="fas fa-comments"></i>
              </h4>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <h3 class="ml-2 card-title title-typography-color">
                  Chat
                </h3>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-item>

      <v-list dense v-if="!chatMini" style="padding: 14px;">
        <div class="message-container flex-grow-1" style="max-height: 800px; overflow-y: auto;padding: 14px;">
          <div
            v-for="(message, index) in messages"
            :key="index"
            ref="message-container"
            class="p-2 my-2 rounded bg-light"
          >
            <div class="message-header">
              <span class="text-muted">{{ message.email }}</span>
              <i class="fas fa-trash-alt ml-auto text-danger cursor-pointer" @click="deleteMessage(message.id)"></i>
            </div>
            <div class="message-body mt-2">
              {{ message.message }}
            </div>
          </div>
        </div>
        <b-form @submit.prevent="sendMessage" class="mt-3">
          <b-input-group>
            <b-form-input v-model="newMessage" placeholder="Escribe un mensaje..."></b-form-input>
            <b-input-group-append>
              <b-button variant="success" type="submit" :disabled="newMessage.length === 0">Enviar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </v-list>
      <v-list dense v-else></v-list>
    </v-navigation-drawer>
  </b-container>
</template>

<script>
import routes from "../../router/index";
import { xray } from "../../config/pluginInit";

import OT from "@opentok/client";
import OtPublisher from "../../components/opentok/ot-publisher";
import OtSubscriber from "../../components/opentok/ot-subscriber";

import scheduleService from "../../services/schedule";
import userService from "../../services/user";

import utilsService from "../../services/utils";

import moment from "moment";

export default {
  components: { OtPublisher, OtSubscriber },
  name: "EventInfo",
  computed: {
    publisherOpts: function () {
      const _opts = {
        insertMode: "append",
        width: "100%",
        height: "100%",
        showControls: true,
      };
      return _opts;
    },
  },
  mounted() {
    xray.index();
    this.getUser();
    this.getEvent(this.eventId);
    this.intervalFinished = setInterval(() => {
      this.checkFinished();
    }, 60000);
    this.init(this.eventId);
    utilsService.auditActivity({
      action: "VIEW",
      module: "PROFESSIONAL_RATINGS",
      info: "",
    });
  },

  methods: {
    startRemainingTimeInterval() {
      this.updateRemainingMinutes(); 
      this.intervalRemainingTime = setInterval(() => {
        this.updateRemainingMinutes();
      }, 60000);
    },
    updateRemainingMinutes() {
      if(this.event.initAt){
        const now = moment();
        const initAt = moment(this.event.initAt);
        const totalMinutes = this.event.visitType.duration + this.event.extraTime;
        const elapsedMinutes = now.diff(initAt, "minutes");
        this.remainingMinutes = totalMinutes - elapsedMinutes;

        // Si el tiempo se agota, detener el intervalo
        if (this.remainingMinutes <= 0) {
          this.remainingMinutes = 0;
          clearInterval(this.intervalRemainingTime);
          if((this.user.role || localStorage.getItem('role')) !== 'PATIENT'){
            this.finish();
          }
        }
      }else{
        this.remainingMinutes = this.event.visitType.duration + this.event.extraTime;
      }
    },
    getFinishAtCalculated(){
      return moment(this.event.startedAt).add(this.event.visitType.duration + this.event.extraTime,"minutes");
    },
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    sendMuteAudioUser(idUser) {

    },
    sendMuteVideoUser(idUser) {

    },
    regenerateUserChat(professionals, patients, professionalLead) {
      let self = this;

      this.usersChat = [];

      if (professionals) {
        professionals.forEach((professional) => {
          let item = {
            id: professional.id,
            name: professional.name + " " + professional.lastname,
            role: "Profesional",
            image: professional.avatarUrl,
            status: "danger",
            you: false,
          };

          if (professional.id == self.user.id) {
            item.status = "success";
            item.you = true;
          }
          //self.getAvatarListUsers(item);

          self.usersChat.push(item);
        });
      }

      if (patients) {
        patients.forEach((patient) => {
          let item = {
            id: patient.id,
            name: patient.name + " " + patient.lastname,
            role: "Paciente",
            image: patient.avatarUrl,
            status: "danger",
            you: false,
          };

          if (patient.id == self.user.id) {
            item.status = "success";
            item.you = true;
          }

          //self.getAvatarListUsers(item);

          self.usersChat.push(item);
        });
      }
      //lead
      if (professionalLead) {
        let item = {
          id: professionalLead.id,
          name: professionalLead.name + " " + professionalLead.lastname,
          role: this.$i18n.t("public.views.Chat.Index.professionalLeadRole"),
          image: professionalLead.avatarUrl,
          status: "danger",
          you: false,
        };

        if (professionalLead.id == self.user.id) {
          item.status = "success";
          item.you = true;
        }

        //self.getAvatarListUsers(item);

        self.usersChat.push(item);
      }
    },
    saveExtraTime() {
      let self = this;

      this.$awn.asyncBlock(
        scheduleService.putExtraTime(
          this.$route.query.event,
          this.timeUpdateSetting
        ),
        (response) => {
          if (response) {
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t("public.views.Chat.Index.notification.title"),
              text:
                this.$i18n.t(
                  "public.views.Chat.Index.notification.notifyIncreaseTime"
                ) +
                self.timeUpdateSetting +
                this.$i18n.t("public.views.Chat.Index.min"),
              type: "success",
            });
            self.timeUpdateSetting = 0;
          }
        },
        (error) => {
          utilsService.genericError(error);
        },
        ""
      );
    },
    async getEvent(id) {
      let self = this;
      this.$awn.asyncBlock(
        scheduleService.getEvent(id),
        (response) => {
          if (response) {
            self.event = response.data;
            //Settings

            self.startRemainingTimeInterval();
            
            self.dateStartSetting = self.event.startedAt;
            self.dateEndSetting = self.event.startedAt;
            /**self.dateEndSetting =  utilsService.adjustDateTime(
              moment(self.event.startedAt).add(
                self.event.visitType.duration + self.event.extraTime,
                "minutes"
              ).format("DD/MM/yyyy") +
                " " +
                this.timeTmp,
              "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
            );*/
            self.timeUpdateRangeMaxSetting = self.event.visitType.duration;
            self.loadUsersChat(response.data);

            //self.getChat(self.event.id);

            self.joinEvent();

            //   self.intervalId = setInterval(() => self.checkInterval(), 5000);
            //Check recording
            // self.btnRecording = response.data.recording;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "ratingService.create",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id,
            }),
          });
        },
        " "
      );
    },
    loadUsersChat(event) {
      let self = this;

        this.regenerateUserChat(
        event.professionals,
        event.patients,
        event.professionalLead
      );
/**  
      self.usersChat.forEach((item) => {
        self.subscribers.forEach((element) => {
          let data = JSON.parse(element.stream.connection.data);

          if (item.id == data.id) {
            item.status = "success";
            self.getAvatarListUsers(item);
          }
        });
      }); */
    },
    async stopScreenSharing() {
      this.$refs.publisher.stopScreenSharing();
    },
    async shareScreenSharing() {
      this.$refs.publisher.startScreenSharing();
    },
    async getUser() {
      let self = this;

      this.$awn.asyncBlock(
        userService.get(localStorage.getItem("userId")),
        (response) => {
          if (response) {
            self.user = response.data;
            if (self.user.timeZone) {
              self.$store.dispatch("Setting/setTimeZoneAction", {
                text: self.user.timeZone,
                value: self.user.timeZone,
              });
            }
            if (self.event && self.event.id) {
              self.loadUsersChat(self.event);
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "userService.get",
            module: "view-pages-professional-dashboard",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId"),
            }),
          });
        }
      );
    },
    async goToDashboard() {
      if (localStorage.getItem("role") === "PATIENT") {
        this.$router.push({ name: "auth.patient.dashboard" });
      } else {
        this.$router.push({ name: "auth.professional.dashboard" });
      }
    },
    async joinEvent() {
      this.callerSession = OT.initSession(
        this.event.apiKey,
        this.event.videoconferenceSession
      );
      this.setupSession();
      this.callerSession.connect(this.event.tokenOpentok, (err) => {
        if (err) {
          console.log(err);
          return;
        }
      });
    },
    async setupSession() {
      let self = this;

      this.callerSession.on("connectionCreated", (event) => {});
      this.callerSession.on("connectionDestroyed", (event) => {
        console.log("Connection destroyed");
      });

      this.callerSession.on("streamCreated", (event) => {
        console.log("Stream created", event.stream);
        self.remoteStreams.push(event.stream);
        self.agentStream = event.stream;
      });

      this.callerSession.on("streamDestroyed", (event) => {
        console.log("Stream destroyed", event.stream);
        self.remoteStreams = self.remoteStreams.filter(s => s.id !== event.stream.id);
        if (self.agentStream && self.agentStream.id === event.stream.id) {
          self.agentStream = self.remoteStreams.length > 0
            ? self.remoteStreams[self.remoteStreams.length - 1]
            : null;
        }
        if (self.remoteStreams.length === 0) {
          self.agentConnected = false;
        }
      });

      this.callerSession.on("signal:msg", function (event) {
        self.messages.push(event.data);
        self.scrollToBottom();
      });

      this.callerSession.on("signal:deleteMessage", function (event) {
        const messageIdToDelete = event.data;
        self.messages = self.messages.filter(message => message.id !== messageIdToDelete);
        self.scrollToBottom();
      });
    },
    async scrollToBottom() {
      this.$nextTick(() => {
        const lastMessageElement = this.$el.querySelector(
          ".message-container > div:last-child"
        );
        if (lastMessageElement) {
          lastMessageElement.scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
          setTimeout(() => {
            const additionalScroll = 200; // Píxeles adicionales que quieres añadir
            const messageContainer = this.$el.querySelector(".message-container");
            if (messageContainer) {
              messageContainer.scrollTop += additionalScroll;
            }
          }, 100); // Ajusta el timeout si es necesario para asegurar que se aplique después de scrollIntoView
        }
      });
    },
    logoutV3() {
      localStorage.removeItem("authorization");
      localStorage.removeItem("userId");
      localStorage.removeItem("organizationId");
      localStorage.removeItem("organizationRoles");
      localStorage.removeItem("type");
      localStorage.removeItem("role");
      localStorage.removeItem("v3");
      this.$router.push({ name: "public.signin" });
    },
    async finish() {
      let self = this;
      this.$awn.asyncBlock(
        scheduleService.setEventFinishAt(this.eventId),
        (response) => {
          if (response) {
            if (localStorage.getItem("v3") === "true") {
              self.logoutV3();
            } else {
              self.goToDashboard();
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "eventService.init",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.eventId,
            }),
          });
        },
        " "
      );
    },
    async setEventExtraTimeEvent() {
      let self = this;
      this.$awn.asyncBlock(
        scheduleService.setEventExtraTimeEvent(self.eventId, 5),
        (response) => {
          self.getEvent(self.eventId);
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "eventService.init",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              eventId: this.eventId,
            }),
          });
        },
        " "
      );
    },
    async init(id) {
      let self = this;

      scheduleService
        .setEventInitAt(id)
        .then((response) => {
          if (response) {
            self.checkFinished();
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "eventService.init",
            module: "view-pages-professional-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id,
            }),
          });
        });
    },
    async errorHandler(err) {
      console.log("Error", err);
    },
    async sendMessage() {
      let self = this;

      let message = {
        id: this.getIdMessage(),
        role: self.user.role,
        message: self.newMessage,
        email: self.user.name,
      };

      this.callerSession.signal(
        {
          type: "msg",
          data: message,
        },
        function (error) {
          if (error) {
            console.log("Error sending signal:", error.name, error.message);
          } else {
            self.newMessage = "";
          }
        }
      );
    },
    async deleteMessage(id) {
      let self = this;

      this.callerSession.signal(
        {
          type: "deleteMessage",
          data: id,
        },
        function (error) {
          if (error) {
            console.log("Error sending signal:", error.name, error.message);
          }
        }
      );
    },
    getIdMessage() {
      return Date.now().toString() + "-" + this.user.email;
    },
    async checkFinished() {
      let self = this;

      scheduleService
        .getEvent(this.eventId)
        .then((response) => {
          if (response) {
            self.event = response.data;
            self.initAt = self.event.initAt;

            if (self.event.finishedAt) {
              self.goToDashboard();
            }
          }
        })
        .catch((error) => {});
    },
    getParticipantById(id) {
      let participant = {
        name: null,
        lastname: null,
        email: null,
        id: null,
      };

      if (
        this.event &&
        this.event.professionalLead &&
        this.event.professionalLead.id == id
      ) {
        participant = {
          name: this.event.professionalLead.name,
          lastname: this.event.professionalLead.lastname,
          email: this.event.professionalLead.email,
          id: this.event.professionalLead.id,
        };
      }
      if (this.event && this.event.patients) {
        this.event.patients.forEach(function (patient) {
          if (patient.id == id) {
            participant = {
              name: patient.name,
              lastname: patient.lastname,
              email: patient.email,
              id: patient.id,
            };
          }
        });
      }
      if (this.event && this.event.professionals) {
        this.event.professionals.forEach(function (professional) {
          if (professional.id == id) {
            participant = {
              name: professional.name,
              lastname: professional.lastname,
              email: professional.email,
              id: professional.id,
            };
          }
        });
      }

      return participant;
    },
  },
  beforeDestroy() {
    if (this.callerSession && this.callerSession.isConnected()) {
      console.log("Disconnecting from session", this.callerSession.sessionId);
      this.callerSession.disconnect();
    }

    if (this.intervalFinished) {
      clearInterval(this.intervalFinished);
    }
    if (this.intervalRemainingTime) {
      clearInterval(this.intervalRemainingTime);
    }
  },

  data() {
    return {
      isScreenSharing: false,
      subscriberOpts: {
        insertMode: "append",
        width: "100%",
        height: '100%',
        fitMode: "contain"
      },
      remoteStreams: [],
      agentStream: null,
      intervalFinished: null,
      intervalRemainingTime: null,
      newMessage: "",
      messages: [],
      callerSession: null,
      eventId: this.$route.query.eventId,
      event: [],
      user: {},
      //Setting
      startVideoconference: true,
      timelastedSetting: 0,
      timelasted: 40,
      timeUpdateSetting: 0,
      dateStartSetting: "",
      dateEndSetting: "",
      timeUpdateRangeMaxSetting: 0,
      chatMini: true,
      mini: true,
      isScreenSharing:false,

      usersChat: [],
      initAt: undefined,
      remainingMinutes: 0,
    };
  },
};
</script>

<style scoped>
.iq-card.flex-fill {
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin-bottom: 0;
}

.iq-card.flex-fill > ::v-deep .iq-card-header {
  min-height: 0;
  padding: 6px 16px;
}

.iq-card.flex-fill > .card-text {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  margin-bottom: 0;
}

.header-actions .btn {
  padding: 4px 12px;
}

.header-actions .m-2 {
  margin: 4px !important;
}

.video-container {
  position: relative;
  height: 100%;
  width: auto;
  max-width: 100%;
  aspect-ratio: 16 / 9;
  margin: 0 auto;
  overflow: hidden;
  min-height: 240px;
}

.subscriber {
  width: 100%;
  height: 100%;
}

.publisher.floating {
  position: absolute;
  bottom: clamp(10px, 2vw, 40px);
  right: clamp(10px, 2vw, 40px);
  width: clamp(180px, 22vw, 300px);
  aspect-ratio: 16 / 9;
  z-index: 100;
  border: 2px solid #1976d2;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  overflow: hidden;
  background-color: #000;
}

.header-actions {
  flex-wrap: wrap;
  row-gap: 4px;
}

@media (max-width: 991px), (max-height: 720px) {
  ::v-deep .iq-card .iq-card-header {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  ::v-deep .iq-card .iq-card-header .btn {
    padding: 4px 8px;
    font-size: 0.85rem;
  }
  ::v-deep .iq-card .iq-card-header .m-2 {
    margin: 4px !important;
  }
}

#publisher {
  width: 100%;
  height: 100%;
}
</style>
